var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col l4 m6 s12"},[_c('router-link',{attrs:{"to":'/nihom-content/'+_vm.data.id}},[_c('div',{staticClass:"card card-content"},[_c('h6',[_vm._v(_vm._s(_vm.data.name))])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }